// core version + navigation, pagination modules:
import Swiper from 'swiper/core';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ( $block ) {


  const setSlideNumber = (sw) => {
    let slidesLength = sw.slides.length;
    let realIndex = sw.realIndex;
    $block.find('.numberSlides').text( realIndex + 1 + ' / ' + slidesLength );
  };

  const swiperContainer = $block.find('.swiper-container');
  const slidesLength = swiperContainer.find('.swiper-slide').length;

  const swiper = new Swiper($block.find('.swiper-container')[0], {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    allowTouchMove: slidesLength > 1,
    runCallbacksOnInit: true,

    on: {
      init: sw => setSlideNumber(sw),
      transitionEnd: sw => setSlideNumber(sw),
    },
  });

  $block.find('.slider-button-next').click(e => {
    e.preventDefault()
    swiper.slideNext();
  })

  $block.find('.slider-button-prev').click(e => {
    e.preventDefault()
    swiper.slidePrev();
  })

}

// Initialize each block on page load (front end).
$(document).ready(function () {
    $('.text-slider-with-image').each(function () {
        initializeBlock($(this));
    });
});

// Initialize dynamic block preview (editor).
if ( window.acf ) {
    window.acf.addAction('render_block_preview/type=slider', initializeBlock);
}
